<template src="./html/Show.html"></template>

<script>
	import swal from 'sweetalert2'
	import Calendar from '../../projects/calendar/views/Index.vue'
	import UsersMap from './UsersMap'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'calendar': Calendar,
			'users-map': UsersMap,
		},
		created () {
			this.init()
		},
		data () {
			return {
				profile: null,
			}
		},
		methods: {
			init() {
				if(this.user.hasRole(['admin', 'manager', 'staff', 'external_manager'])) {
					if(this.user.hasRole('staff')) {
						if(this.$route.params.id == this.user.id) {
							this.getData()
						}
					} else {
						this.getData()
					}
				}
			},
			getData() {
				this.$http.get('admin/users/' + this.$route.params.id)
				.then(response => {
					this.profile = response.body
				}).catch(function(response) {
					console.log(response)
					console.log(response)
				})
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/users/views/Show.vue